<template>
    <div class="white-rounded-box pl-7 pt-7 mb-4">
        <div class="white-rounded-box pl-7 pt-5 mr-4">
            <h1>Profile Info</h1>
            <div>
                <button
                    type="button"
                    @click="submitChanges"
                    class="flex mx-auto -mt-11 pl-5 text-white storefront-btn-blue font-medium rounded-lg text-sm px-5 py-2.5 mr-7 mb-2 dark:hover:bg-blue-700 focus:outline-none dark:focus:ring-blue-800"
                    :disabled="formData.profileInfo.display_name == ''"
                >
                    <svg-vue
                        v-if="isSavingProfileInfo"
                        icon="loader"
                        title="Loading"
                    />
                    Save
                </button>
            </div>
            <div class="p-3">
                <div class="flex items-center mt-4">
                    <h2 class="flex-1 text-base text-black text-right">
                        Display Name
                    </h2>
                    <input
                        type="text"
                        class="w-5/6 rounded-lg ml-4"
                        :placeholder="user.display_name"
                        v-model="formData.profileInfo.display_name"
                    />
                </div>
<!--
                <div class="flex items-center mt-4" v-if="user.type == 'pro'">
                    <h2 class="flex-1 text-base text-black text-right">Bio</h2>
                    <textarea
                        rows="3"
                        cols="60"
                        maxlength="250"
                        class="rounded-lg w-5/6 ml-4"
                        placeholder="Enter the Bio for the Storefront page"
                        v-model="formData.profileInfo.user_bio"
                    />
                </div>
-->
                <div class="flex items-center mt-4" v-if="user.type == 'pro'">
                    <h2 class="flex-1 text-base text-black text-right">
                        Business/Organization
                    </h2>
                    <input
                        type="text"
                        v-model="formData.profileInfo.org_name"
                        class="rounded-lg w-5/6 ml-4"
                        :placeholder="user.org_name"
                    />
                </div>
                <div class="flex items-center mt-4" v-if="user.type == 'pro'">
                    <h2 class="flex-1 text-base text-black text-right">
                        Profession
                    </h2>
                    <t-rich-select
                        v-model="formData.profileInfo.selectedProfession"
                        :options="professions"
                        class="w-5/6 ml-4"
                        :textAttribute="'tag'"
                        noResultsText="Can't find your profession? you'll be able to create a new one in future releases of salesium"
                    />
                </div>
            </div>
            <div class="p-4 flex flex-col w-full">
                <div class="flex items-center gap-x-4 mt-4 w-full">
                    <h1 class="text-base text-black ml-4">Notify Me By</h1>
                    <t-select
                        class="rounded-lg w-1/3 text-black pl-4"
                        :options="preferredNotificationOptions"
                        variant="demo"
                        v-model="formData.profileInfo.notifications"
                        @change="checkForSMSError"
                    ></t-select>
                    <div v-if="user.type == 'pro'" class="ml-3 flex">
                        <p>Auto Accept Connections</p>
                        <t-toggle
                            unchecked
                            class="ml-4 flex h-6"
                            v-model="formData.automaticConnections"
                        />
                    </div>
                </div>
                <div class="w-full mt-2">
                    <t-alert variant="danger" :show="showSMSError" @hidden="showSMSError = false">
                        Please make sure you have a primary phone number added below to receive text/SMS!
                    </t-alert>
                </div>
            </div>
        </div>
        <div class="white-rounded-box pl-7 pt-1 mr-4 mt-3 mb-2">
            <AccountStatus :user="user" />
        </div>
        <div class="white-rounded-box pl-7 pt-1 mr-4 mt-3 mb-2">
            <div class="inline ml-4">
                <h1 class="mt-4">Contact Information</h1>
                <!-- tabs removed for MVP, backend only supports one set of contact info right now -->
                <ul
                    v-if="false"
                    class="flex text-sm font-medium text-center mx-auto content-center items-centers"
                >
                    <li class="w-1/2 border-b-2 border-salesium-blue">
                        <a
                            @click="showPersonal"
                            aria-current="page"
                            class="inline-block w-full p-4 rounded-lg text-xl dark:hover:bg-salesium-blue dark:hover:text-white no-underscore rounded-b-none"
                            :class="
                                formData.infoType == 'personal'
                                    ? 'bg-salesium-blue text-white'
                                    : 'text-black'
                            "
                        >
                            Personal
                        </a>
                    </li>
                    <li class="w-1/2 border-b-2 border-salesium-blue">
                        <a
                            @click="showBusiness"
                            class="inline-block w-full p-4 rounded-lg text-xl dark:hover:bg-salesium-blue dark:hover:text-white no-underscore rounded-b-none"
                            :class="
                                formData.infoType == 'business'
                                    ? 'bg-salesium-blue text-white '
                                    : 'text-black'
                            "
                        >
                            Business
                        </a>
                    </li>
                </ul>
            </div>
            <div>
                <ContactInfo :user="user" />
            </div>
        </div>
    </div>
</template>
<script>
import ContactInfo from "./ContactInfo.vue";
import AccountStatus from "./AccountStatus.vue";
export default {
    props: ["user", "professions"],
    data() {
        return {
            formData: {
                infoType: "personal",
                profileInfo: {
                    display_name: this.user.display_name,
                    notifications: this.user.preferred_notification,
                    user_bio: this.user.about,
                    selectedProfession: this.user.subindustry_id,
                    org_name: this.user.org_name,
                },
                automaticConnections: this.user.auto_connect,
            },
            isSavingProfileInfo: false,
            preferredNotificationOptions: [
                { value: 1, text: "Email" },
                { value: 0, text: "Ping" },
                { value: 2, text: "Text/SMS" },
            ],
            showSMSError: false,
        };
    },
    methods: {
        showPersonal() {
            this.formData.infoType = "personal";
            this.showInfo = "true";
        },
        showBusiness() {
            this.formData.infoType = "business";
            this.showInfo = "true";
        },

        async submitChanges() {
            this.isSavingProfileInfo = true;
            console.log( this.formData.profileInfo.org_name);
            console.log( this.formData.profileInfo.user_bio);
            await axios
                .post("/api/user", {
                    display_name: this.formData.profileInfo.display_name,
                    preferred_notification: parseInt(
                        this.formData.profileInfo.notifications
                    ),
                    about: this.formData.profileInfo.user_bio,
                    auto_connect: this.formData.automaticConnections,
                    subindustry_id:
                        this.formData.profileInfo.selectedProfession,
                    org_name:
                        this.formData.profileInfo.org_name,
                })
                .then((response) => {
                    this.isSavingProfileInfo = false;
                    this.$toasted.global.toast_success('Save Successful');
                })
                .catch((error) => {
                    console.log(error);
                    alert("something went wrong!");
                });
        },
        checkForSMSError(event){
            if(event == 2){
                if(!this.user.phones[0]){
                    this.showSMSError = true;
                }
            }
        }
    },
    components: {
        ContactInfo,
        AccountStatus,
    },
};
</script>

<style>
.active {
    background-color: darkred;
}
</style>
